import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from './store';
import "@fortawesome/fontawesome-free/css/all.css";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faFacebookSquare,
  faTwitter,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faFacebookSquare, faTwitter, faInstagram);

createApp(App)
  .use(store)  
  .use(router) 
  .component("font-awesome-icon", FontAwesomeIcon) 
  .mount("#app"); 
